import { useTheme } from '@mui/material'
import icons from '../assets/icons'
import RectButton, { iconSizes, RectButtonProps } from './RectButton'
import StyledIcon from './StyledIcon'
import { MaterialColor } from '~/theme/default'

interface Props extends Omit<RectButtonProps, 'children' | 'startIcon8' | 'endIcon8'> {
  icon8: keyof typeof icons
  color?: 'primary' | 'secondary' | 'error' | 'warning'
  size?: 'small' | 'medium' | 'large' | 'tiny'
}

const CircleButton = (props: Props) => {
  const { sx, icon8, color, ...rest } = props
  const theme = useTheme()

  const iconColor =
    props.variant === 'outlined'
      ? theme.palette[color || 'primary'].main as MaterialColor
      : theme.palette[color || 'primary'].contrastText as MaterialColor
  const iconSize = iconSizes[props.size || 'medium']

  let padding = 1
  if (props.size === 'small') padding = 0.8
  if (props.size === 'tiny') padding = 0.5

  return <RectButton
    {...rest}
    iconSize={props.size}
    color={color}
    sx={{
      ...sx,
      borderRadius: '50%',
      minWidth: 0,
      p: padding,
      flexShrink: 0,
      '& .MuiButton-icon': {
        margin: 0,
      },
      '& .MuiButton-icon img': {
        margin: 0,
      },
      '&:disabled': {
        opacity: 0.3,
      },
    }}
  >
    <StyledIcon name={icon8} color={iconColor} size={iconSize} />
  </RectButton>
}

export default CircleButton
